/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Alert, AlertTitle, Box, Breadcrumbs, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, Divider, FormControlLabel, FormGroup, Link, List, Paper, Slide, Slider, Snackbar, Stack, TextField, Typography } from '@mui/material'
import React, { type ReactElement, useCallback, useState, useMemo, useEffect } from 'react'
// import { CustomDropzone } from './DropZone'
import { useDropzone } from 'react-dropzone'
import Papa from 'papaparse'
import axios from 'axios'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined'
import { Infom } from './Info'
import { useProjectStore } from '../hooks/projectwizardStore'
import { NavigateNext } from '@mui/icons-material'

const baseStyle: any = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '60px',
  borderWidth: 2,
  borderRadius: 10,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
}

const focusedStyle = {
  borderColor: '#2196f3'
}

const acceptStyle = {
  borderColor: '#00e676'
}

const rejectStyle = {
  borderColor: '#ff1744'
}
interface IpreProcessor {
  key: string
  value: string
  checked: boolean
}

export const UnLabelledDataUpload = (props: { projectMasterId: number, projectName: string | undefined }): ReactElement<React.FC> => {
  const [data, setData] = useState<any>([])
  const [preProcessor, setPreProcessor] = useState<IpreProcessor[]>([
    { key: 'force_lowercase', value: 'Force Text to Lowercase', checked: true },
    { key: 'social_text', value: 'Remove Common Social Texts', checked: false },
    { key: 'numbers', value: 'Remove Numbers', checked: true },
    { key: 'special_chars', value: 'Remove Special Characters', checked: true },
    { key: 'stop_words', value: 'Remove Stop Words', checked: true },
    { key: 'stem_terms', value: 'Stem Terms', checked: false }
  ])
  const [dataColumns, setDataColumns] = useState<any[]>([])
  const [csvFile, setCsvFile] = useState<any>()
  const [csvParsed, setCsvParse] = useState<boolean>(false)
  const { instance, accounts } = useMsal()
  const [showSnackBar, setShowSnackBar] = useState(false)
  const [showFileSizeSnackBar, setShowFileSizeSnackBar] = useState(false)
  const [snackBarMessage, setSnackBarMessage] = useState<null | string>(null)
  const [threshold, setThreshold] = useState<number | number[]>(80)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [dialog, showDialog] = useState<boolean>(false)
  const [uploaded, setUploaded] = useState<boolean>(false)
  const { enableNextStack, disableNextStack } = useProjectStore(state => state)
  const onDrop = useCallback((acceptedFiles: any[]) => {
    setCsvFile(acceptedFiles[0])
  }, [])

  useEffect(() => {
    void getProjectDetails()
  }, [])

  const getProjectDetails = async (): Promise<any> => {
    setIsLoading(true)
    const token = await getAccessToken(process.env.REACT_APP_API_SCOPE as string)
    const apiUrl = process.env.REACT_APP_API_URL as string
    if (token !== undefined) {
      const config = {
        method: 'get',
        url: `${apiUrl}/project/${props.projectMasterId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
      const response = await axios(config)
      setIsLoading(false)

      if (response.status === 200) {
        const data: any[] = response.data.data
        // if ProjectFileMasterId === 1 then that object is selected for filling the form
        const selectedData = data.filter((item) => item.ProjectFileMasterId === 2)
        if (selectedData.length > 0) {
          const remoteLabelledData: any = selectedData[0]
          // get file name from the string in project file location s3://lly-ladl-1k6clvz1/192/20ng_labeled_subset.csv-cleaned.csv this is the name 20ng_labeled_subset.csv-cleaned.csv
          if (remoteLabelledData.ProjectFileLocation !== null) {
            const fileName = remoteLabelledData.ProjectFileLocation.split('/')[5]
            setCsvFile({ name: fileName })
          }
          if (remoteLabelledData.ProjectUnlabelledDataColumns !== null) {
            const dataColumns = remoteLabelledData.ProjectUnlabelledDataColumns.split(',')
            setData(dataColumns)
            setDataColumns(dataColumns)
            setCsvParse(true)
          }
          if (remoteLabelledData.ProjectThreshold !== null) {
            setThreshold(remoteLabelledData.ProjectThreshold)
          }
          // set preprocessor values
          if (remoteLabelledData.ProjectPreProcessor !== null) {
            const preProcessorValues = remoteLabelledData.ProjectPreProcessor.split(',')
            const preProcessorData = preProcessor.map((item) => {
              if (preProcessorValues.includes(item.key)) {
                return { ...item, checked: true }
              } else {
                return { ...item, checked: false }
              }
            }
            )
            setPreProcessor(preProcessorData)
          }
          setUploaded(true)
          enableNextStack()
        } else {
          disableNextStack()
        }
      }
    }
  }

  const onProceed = (): void => {
    const reader: any = new FileReader()

    reader.onabort = () => { console.log('file reading was aborted') }
    reader.onerror = () => { console.log('file reading failed') }
    reader.onload = async () => {
      const csv = Papa.parse(reader.result, {
        header: true
      })
      const parsedData: any = csv?.data
      if (parsedData.length > 0) {
        const columns: any = Object.keys(parsedData[0])
        // remove bom character from the first column name
        const bom = '\uFEFF'
        const test = columns[0].replace(bom, '')
        console.log('Bom removed', test)
        const regex = /^[a-zA-Z0-9_ -]*$/
        if (columns.every((col: string) => regex.test(col))) {
          setData(columns)
          setCsvParse(true)
        } else {
          alert('Invalid column names - Column names can only contain alphanumeric characters, underscores and hyphens')
        }
      } else {
        console.log('No Data Found in the csv file')
        alert('Uploaded file does not adhere to the expected format')
      }
    }

    reader.readAsText(csvFile, 'UTF-8')
  }

  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone(
    {
      validator: (file) => {
        if (file.type !== 'text/csv') {
          setShowSnackBar(true)
          return {
            code: 'invalid-file-type',
            message: 'only CSV files are allowed'
          }
        }
        if (file.size > 6000000) {
          setShowFileSizeSnackBar(true)
          return {
            code: 'size-too-large',
            message: 'file is larger than 6MB'
          }
        }
        return null
      },
      onDrop,
      maxFiles: 1,
      useFsAccessApi: false,
      accept: {
        'text/csv': ['.csv']
      }
    })
  const style: any = useMemo(() => ({
    ...baseStyle,
    ...((isFocused) ? focusedStyle : {}),
    ...((isDragAccept) ? acceptStyle : {}),
    ...((isDragReject) ? rejectStyle : {})
  }), [
    isFocused,
    isDragAccept,
    isDragReject
  ])
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    console.log(event.target.value, event.target.checked)
    const { value, checked }: { value: string, checked: boolean } = event.target
    if ((checked && !dataColumns.includes(value)) || dataColumns.length === 0) {
      setDataColumns(prevState => [...prevState, value])
    }

    if (!checked && dataColumns.length > 0 && dataColumns.includes(value)) {
      console.log('removed' + value)
      const tempDataColumns: any = dataColumns.filter(x => x !== value)
      setDataColumns(tempDataColumns)
    }
  }

  const handlePreprocessorChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    console.log(event.target.value, event.target.checked)
    const { value, checked }: { value: string, checked: boolean } = event.target
    const tempPreProcessor = preProcessor.map((preProcessorObj) => {
      if (preProcessorObj.key === value) {
        preProcessorObj.checked = checked
      }
      return preProcessorObj
    }
    )
    console.log(tempPreProcessor)
    setPreProcessor(tempPreProcessor)
  }

  function pick (obj: any, keys: any): any {
    const result: any = {}
    for (const key of keys) {
      result[key] = obj[key]
    }
    return result
  }

  const getAccessToken = async (scope: string): Promise<string | undefined> => {
    if (accounts.length > 0) {
      const request = {
        scopes: [`${scope}`],
        account: accounts[0]
      }
      try {
        const response = await instance.acquireTokenSilent(request)
        return response.accessToken
      } catch (error) {
        // acquireTokenSilent can fail for a number of reasons, fallback to interaction
        if (error instanceof InteractionRequiredAuthError) {
          const response = await instance.acquireTokenPopup(request)
          return response.accessToken
        }
      };
    }
  }

  const uploadFile = (): void => {
    console.log(dataColumns, threshold)
    if (dataColumns.length === 0) {
      alert('Please select Data Columns')
      return
    }
    if (preProcessor.filter((preProcessorObj) => preProcessorObj.checked).length === 0) {
      alert('Please select atleast one preprocessor')
      return
    }
    if (csvFile === undefined) {
      alert('Please select a File')
      return
    }
    showDialog(true)
  }

  const dialogProceed = (): void => {
    showDialog(false)
    setIsLoading(true)
    const preProcessorString = preProcessor.filter((preProcessorObj) => preProcessorObj.checked).map((preProcessorObj) => preProcessorObj.key).join(',')
    const reader: any = new FileReader()
    reader.onabort = () => { console.log('file reading was aborted') }
    reader.onerror = () => { console.log('file reading failed') }
    reader.onload = async () => {
      const csv: any = Papa.parse(reader.result, {
        header: true
      })
      const parsedData: any = csv?.data
      const filteredData = parsedData.map((data: any) => pick(data, dataColumns))
      console.log('Filtered Data::', filteredData)
      const cleanedUpCsv = Papa.unparse(filteredData)
      console.log('Cleaned up CSV', cleanedUpCsv)
      const blob = new Blob([cleanedUpCsv], { type: 'text/csv' })
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      const file = new File([blob], `${csvFile.name}`, { type: 'text/csv' })
      // upload file from here
      console.log(file)
      const formData = new FormData()
      formData.append('csv', file)
      const token = await getAccessToken(process.env.REACT_APP_API_SCOPE as string)
      const apiUrl = process.env.REACT_APP_API_URL as string
      if (token !== undefined) {
        const config = {
          method: 'post',
          url: `${apiUrl}/dataset/upload?projectId=${props.projectMasterId}&threshold=${threshold.toString()}&preprocessor=${encodeURIComponent(preProcessorString)}&unlabelledDataColumns=${encodeURIComponent(dataColumns.filter(Boolean).join(','))}&delimiter=,`,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          },
          data: formData
        }
        const response = await axios(config)
        console.log(response)
        setIsLoading(false)
        if (response.status === 200) {
          setSnackBarMessage('File uploaded Successfully')
          await getProjectDetails()
        }
      }
    }
    console.log('csv File parsed', csvFile)

    reader.readAsText(csvFile)
  }

  const handleThresholdChange = (_event: Event, value: number | number[], _activeThumb: number): void => {
    setThreshold(value)
  }

  const clearForm = (): void => {
    setDataColumns([])
    setThreshold(80)
    setCsvFile(undefined)
    setCsvParse(false)
    setUploaded(false)
    setData([])
    disableNextStack()
    setPreProcessor([
      { key: 'force_lowercase', value: 'Force Text to Lowercase', checked: true },
      { key: 'social_text', value: 'Remove Common Social Texts', checked: false },
      { key: 'numbers', value: 'Remove Numbers', checked: true },
      { key: 'special_chars', value: 'Remove Special Characters', checked: true },
      { key: 'stop_words', value: 'Remove Stop Words', checked: true },
      { key: 'stem_terms', value: 'Stem Terms', checked: false }
    ])
  }

  return <Paper variant="outlined" style={{ padding: '20px', height: '85%' }} className="mt-5">
    <Breadcrumbs separator={<NavigateNext fontSize="small" />} sx={{ mb: 3 }} aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/">
          <Typography fontSize={20} sx={{ fontWeight: '500' }}>{props.projectName}</Typography>
          </Link>
          <Typography fontSize={20} sx={{ fontWeight: '500' }} color="text.primary">Unlabelled data upload</Typography>
        </Breadcrumbs>
    { isLoading
      ? <Box height={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'}><CircularProgress /></Box>
      : <Stack
      direction="row"
      sx={{ height: '90%' }}
      divider={<Divider orientation="vertical" flexItem />}
      spacing={2}
      alignItems={'center'}
      justifyContent={'space-evenly'}
    >
      <Box width={'40%'} display={'flex'} flexDirection={'column'}>
        <Typography fontWeight={'bold'} paddingBottom={2}>
          Document Upload <Infom info='Please select the data set file you wish to upload to act as the unlabelled data. Please note only .csv file types are currently accepted.' />
        </Typography>
        {csvFile === undefined && <div {...getRootProps({ style })}>
          <input {...getInputProps()} />
          <p><span style={{ color: '#0276aa' }}>Click to select files </span>or drag and drop .csv file up to 6MB</p>
        </div>}
        {csvFile !== undefined && <div style={baseStyle}><Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
          <ArticleOutlinedIcon fontSize='large' sx={{ alignSelf: 'center' }} />
          <p className='text-slate-500'>{csvFile.name} <HighlightOffOutlinedIcon onClick={clearForm} fontSize='small' sx={{ alignSelf: 'center', cursor: 'pointer' }} /></p>
        </Box></div>}
        <Typography fontWeight={'bold'} paddingY={'10px'}>
          Delimiter <Infom info='This is currently restricted to Comma as only .csv files are accepted at this time' />
        </Typography>
        <TextField disabled={uploaded} id="delimiter" value={'comma'} variant="outlined" />
        <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'}>
        <Button sx={{ mt: 4, mx: 2, alignSelf: 'flex-end' }} size='large' variant='outlined' disabled={csvFile === undefined || uploaded} onClick={clearForm} >Cancel</Button>
        <Button sx={{ mt: 4, alignSelf: 'flex-end' }} size='large' variant='contained' disabled={csvFile === undefined || uploaded || csvParsed} onClick={onProceed} >Proceed</Button>
        </Box>
      </Box>
      {csvParsed && <Slide direction="left" timeout={500} in mountOnEnter unmountOnExit>
        <Box width={'40%'}>
        <Typography fontWeight={'bold'} paddingBottom={'5px'}>
          Select Data Columns <Infom info='Please select the data columns you wish the automated process to review in this file' />
        </Typography>
        <FormGroup>
        <List style={{
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'scroll',
          maxHeight: '150px',
          borderWidth: 2,
          borderRadius: 2,
          borderColor: '#eeeeee',
          paddingLeft: '15px'
        }} >
          {data.map((col: any, idx: any) => <FormControlLabel disabled={uploaded} key={idx} control={<Checkbox sx={{ padding: '5px' }} value={col} checked={dataColumns.includes(col)} onChange={handleChange} />} label={col} />)}
        </List>
        </FormGroup>
        <Typography fontWeight={'bold'} paddingY={'5px'}>
          Threshold % <Infom info='The threshold is the target level % of confidence the data labelling process will need to meet to automatically label the data with no user review. Any data items that fall below this % threshold will be routed for user review and approval.' />
        </Typography>
        <Slider disabled={uploaded} valueLabelDisplay="on" onChange={handleThresholdChange} aria-label="Always visible" defaultValue={threshold} value={threshold} />
        <Typography fontWeight={'bold'} paddingY={'5px'}>
          Select Preprocessors
        </Typography>
        <List style={{
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'scroll',
          maxHeight: '120px',
          borderWidth: 2,
          borderRadius: 2,
          borderColor: '#eeeeee',
          paddingLeft: '15px'
        }} >
          {preProcessor.map((preProcessorObj, idx) => <FormControlLabel disabled={uploaded} key={idx} control={<Checkbox sx={{ padding: '5px' }} defaultChecked={preProcessorObj.checked} value={preProcessorObj.key} onChange={handlePreprocessorChange} />} label={preProcessorObj.value} />)}
        </List>
        <Button sx={{ mt: 2 }} size='large' variant='contained' disabled={uploaded} onClick={uploadFile} >Upload</Button>
      </Box></Slide>}
    </Stack>}
    <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={showSnackBar} onClose={() => { setShowSnackBar(false) }} autoHideDuration={6000} >
      <Alert sx={{ width: '100%' }} variant="filled" severity="error"> <AlertTitle>Invalid file</AlertTitle>Only CSV files are supprorted</Alert>
    </Snackbar>
    <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={showFileSizeSnackBar} onClose={() => { setShowFileSizeSnackBar(false) }} autoHideDuration={6000} >
      <Alert sx={{ width: '100%' }} variant="filled" severity="error"> <AlertTitle>File size exceeds limit</AlertTitle>File size cannot exceed 6MB limit</Alert>
    </Snackbar>
    <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={snackBarMessage !== null} onClose={() => { setSnackBarMessage(null) }} autoHideDuration={6000} >
      <Alert sx={{ width: '100%' }} variant="filled" severity="success"> <AlertTitle>Success</AlertTitle>{snackBarMessage}</Alert>
    </Snackbar>
    <Dialog
        open={dialog}
        onClose={() => { showDialog(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent
          sx={{ px: 8, pt: 6 }}
        >
          <DialogContentText id="alert-dialog-description">
            Do you want to upload the document?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={() => { showDialog(false) }}>
            No
          </Button>
          <Button variant='contained' onClick={() => { dialogProceed() }} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
  </Paper>
}
